import React from "react";
import { Box, Flex, Text } from "theme-ui";
import PropTypes from "prop-types";
import { DisplayIcon } from '../atoms';
import { colors, typography } from '../../styles/theme';

const InfoCard = ({
  iconName,
  theme,
  iconColor,
  heading,
  subTitle,
  backgroundColor,
  desc,
  border,
  customStyles,
  containerCustomStyles,
}) => {
  return (
    <Flex
      sx={{
        flexDirection: "column",
        position: "relative",
        display: "inline-flex",
        ...containerCustomStyles,
      }}
    >
      <Flex
        sx={{
          border: border,
          backgroundColor: backgroundColor,
          ...cardContainer,
          ...customStyles,
        }}
      >
        <DisplayIcon
          iconName={iconName}
          theme={theme}
          iconColor={iconColor}
          iconStyles={{
            minWidth: "4rem",
            mr: "0.75rem",
          }}
        />
        <Flex
          sx={{
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {heading && (
            <Text
              sx={{
                ...typography.textMd500,
                textAlign: "left",
              }}
            >
              {heading}
            </Text>
          )}
          {subTitle && (
            <Text
              sx={{
                ...typography.textSm,
                color: colors.neutral900,
                textAlign: "left",
              }}
            >
              {subTitle}
            </Text>
          )}
        </Flex>
      </Flex>
      {desc && (
        <Box
          sx={{
            ...descContainer,
            backgroundColor: `${colors[`${theme}100`]}`,
            border: `1px solid ${colors.neutral200}`,
          }}
        >
          <Text
            sx={{
              ...typography.textMd400,
              color: colors.neutral900,
            }}
          >
            {desc}
          </Text>
        </Box>
      )}
    </Flex>
  );
};

const { cardContainer, descContainer } = {
  cardContainer: {
    borderRadius: "1rem",
    padding: "1rem",
  },
  descContainer: {
    p: "1.5rem 2rem",
    borderRadius: "0 0 1rem 1rem",
    position: "relative",
    bottom: "0.625rem",
    zIndex: -1,
  },
};

InfoCard.propTypes = {
  iconName: PropTypes.string.isRequired,
  theme: PropTypes.string,
  iconColor: PropTypes.string,
  heading: PropTypes.string,
  subTitle: PropTypes.string,
  backgroundColor: PropTypes.string,
  desc: PropTypes.string,
  border: PropTypes.string,
  customStyles: PropTypes.object,
  containerCustomStyles: PropTypes.object,
};

InfoCard.defaultProps = {
  iconName: "Landmark",
  theme: "primary",
  iconColor: colors.white,
  heading: "InfoCard",
  backgroundColor: colors.white,
  customStyles: {},
  containerCustomStyles: {},
};

export default InfoCard;
